// A simple debugger module which only debugs on environments that are not production
const debug = (msg: string, object: unknown = null) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(
      JSON.stringify({ type: 'Console', data: { msg, object } }),
    );
  }

  if (
    import.meta.env.VITE_APP_DEBUG === 'true' ||
    sessionStorage.getItem('TestMode') === 'true'
  ) {
    // eslint-disable-next-line no-console
    console.log(msg, object);
    return true;
  }

  return false;
};

export default debug;
